import { InfiniteSearchSelect, SelectProps } from '../../common/components';
import { useInfiniteSearchClassifiersQuery } from '../query/useSearchClassifiersQuery';

export interface ClassifierAutoCompleteProps extends SelectProps {
  selectedClassifier?: string;
}

export function ClassifierAutoComplete(props: ClassifierAutoCompleteProps) {
  const { selectedClassifier, ...rest } = props;

  return (
    <InfiniteSearchSelect
      {...rest}
      searchOptions={selectedClassifier}
      useSearchHook={useInfiniteSearchClassifiersQuery}
    />
  );
}
